module.exports = __webpack_public_path__ + "img/sdg_en_(9).8052810b.png";